import RouteContainer from 'containers/RouteContainer';
import Component from './containers/MedicationContainer';

export const path = `${DOCUMENTS_PATH}/medication`;
export const navMedication = { name: 'medication', id: 'medication.title' };
export const navVitamin = { name: 'vitamin', id: 'medication.title', nonNavigable: true };

export default RouteContainer(path, Component);
